import { STATIC_HM_PATH } from "@project/shared-types";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../../core/core";
import "./BigBlock.css";

export const MiddleBlock = ({ block, ...props }: { block: any }) => {
  return (
    <div className={"big-block "}>
      <Title type={_sizeHeading.h2}>{block.title}</Title>
      <div className="big-block-body middle-body">
        <div className="big-block-t">
          <div className="middle-group">
            <div className="big-card">
              <Title type={_sizeHeading.h3}>{block.card_title_1}</Title>
              <div className="big-card-info">
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_text_1}
                </Text>
                <div className="big-card-lable">
                  <Text size={_sizeText.m} color={_colorText.black}>
                    {block.card_small_1}
                  </Text>
                </div>
              </div>
            </div>
            <div className="big-card">
              <Title type={_sizeHeading.h3}>{block.card_title_2}</Title>
              <div className="big-card-info">
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_text_2}
                </Text>
                <div className="big-card-lable">
                  <Text size={_sizeText.m} color={_colorText.black}>
                    {block.card_small_2}
                  </Text>
                </div>
              </div>
            </div>
          </div>
          <div className="big-card middle-card-img">
            <Title type={_sizeHeading.h3} color={_colorText.black}>
              {block.card_title_3}
            </Title>
            <div className="big-card-info">
              <Text size={_sizeText.m} color={_colorText.black}>
                {block.card_text_3}
              </Text>
              <div className="big-card-lable">
                <Text size={_sizeText.m} color={_colorText.black}>
                  {block.card_small_3}
                </Text>
              </div>
            </div>
            <div className="middle-image">
              <img src={`${STATIC_HM_PATH}/images/middletext.webp`}></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
